import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import { gridMargin } from './general';

const styles = () => {
	return {
		chips: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		chip: {
			margin: `1px 2px 1px 2px`,
		},
		dense: {
			padding: 5,
		},
	};
};

class FormMultiSelect extends PureComponent {
	handleChange = (event) => {
		const { onChange, path } = this.props;
		onChange(event.target.value, path);
	};

	render() {
		const {
			label,
			value,
			path,
			error,
			options,
			helpText,
			disabled,
			gridProps,
			classes,
		} = this.props;

		//let value, onChange, error;
		const hasError = !!error;
		const content = (
			<FormControl fullWidth={true} error={hasError} disabled={disabled}>
				<InputLabel htmlFor={path}>{label}</InputLabel>
				<Select
					multiple
					value={value}
					onChange={this.handleChange}
					input={<Input name={path} id={path} />}
					renderValue={(selected) => {
						const displaySelected = selected.length > 2 ? selected.slice(0, 1) : selected;
						const extraCount = selected.length - displaySelected.length;

						return (
							<div className={classes.chips}>
								{displaySelected.map((value) => {
									const option = _.find(options, { value }) || { display: 'Missing' };
									const style = option.style ? option.style : {};

									return (
										<Chip
											key={value}
											label={_.get(option, 'display')}
											className={classes.chip}
											style={style}
										/>
									);
								})}
								{extraCount > 0 && (
									<Chip key="extra" label={`+${extraCount} more`} className={classes.chip} />
								)}
							</div>
						);
					}}
				>
					{options &&
						options.map((option) => {
							return (
								<MenuItem key={option.value} value={option.value}>
									<Checkbox
										size={'small'}
										classes={{ root: classes.dense }}
										checked={value.indexOf(option.value) > -1}
									/>
									{option.display}
								</MenuItem>
							);
						})}
				</Select>
				{hasError && <FormHelperText>{error}</FormHelperText>}
				{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
			</FormControl>
		);

		if (gridProps) {
			_.defaults(gridProps, { xs: 12 });
			return (
				<Grid item {...gridProps} style={gridMargin}>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FormMultiSelect.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.array,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,
	options: PropTypes.array.isRequired,
	helpText: PropTypes.string,
	disabled: PropTypes.bool,
	gridProps: PropTypes.object,
};

export default withStyles(styles)(FormMultiSelect);
